import { useDispatch, useSelector } from 'react-redux';

import { ArtworkDynamicData, ArtworksState } from '@definitions/artworks.types';
import { GlobalState } from '@modules/createStore';
import { plpActions, plpSelectors } from '@modules/plp';
import { artworksDomain } from '@modules/artworks/artworks.selectors';
import { ACTION_PREFIX } from '@modules/plp/plp.constants';

export const useSetArtworkDynamicData = () => {
  const dispatch = useDispatch();

  const artworkDynamicData = useSelector(
    plpSelectors.selectArtworkDynamicData(artworksDomain as (state: GlobalState) => ArtworksState)
  );
  const setArtworkDynamicData = (data: ArtworkDynamicData) =>
    dispatch(plpActions.setArtworkDynamicData(ACTION_PREFIX.ARTWORKS)(data));

  return { artworkDynamicData, setArtworkDynamicData };
};
